
import { Link } from "react-router-dom";
import { Facebook, Linkedin, Mail, Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div className="space-y-4">
            <img 
              src="/lovable-uploads/c7ab57c0-ad06-4bfe-ba49-7a038974d7c5.png" 
              alt="Agro" 
              className="h-12"
            />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Agro, votre partenaire privilégié pour des solutions innovantes et durables dans l&apos;industrie laitière. 
              Nous sommes fiers de servir la région du Centre-du-Québec, de l&apos;Estrie et de Lotbinière avec engagement et intégrité.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/agrorefrigeration/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-accent transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/agro-r%C3%A9frig%C3%A9ration-inc/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-accent transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contactez-nous */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contactez-nous:</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 text-muted-foreground flex-shrink-0" />
                <div>
                  <p className="font-medium">Par téléphone:</p>
                  <a href="tel:8197529288" className="text-accent hover:underline">
                    (819) 752-9288
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 text-muted-foreground flex-shrink-0" />
                <div>
                  <p className="font-medium">Par courriel:</p>
                  <a href="mailto:admin@agroref.ca" className="text-accent hover:underline">
                    admin@agroref.ca
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <MessageCircle className="w-4 h-4 mt-1 text-muted-foreground flex-shrink-0" />
                <div>
                  <p className="font-medium">Par Messenger:</p>
                  <a href="https://www.facebook.com/agrorefrigeration/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                    Agro Réfrigération inc
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation rapide */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Navigation rapide</h3>
            <div className="flex flex-col space-y-2 text-sm">
              <Link to="/a-propos" className="text-muted-foreground hover:text-accent transition-colors">
                À propos de nous
              </Link>
              <Link to="/" className="text-muted-foreground hover:text-accent transition-colors">
                Nos Produits
              </Link>
              <Link to="/services" className="text-muted-foreground hover:text-accent transition-colors">
                Nos Services
              </Link>
              <Link to="/projets" className="text-muted-foreground hover:text-accent transition-colors">
                Projets et Événements
              </Link>
              <Link to="/blogue" className="text-muted-foreground hover:text-accent transition-colors">
                Blogue
              </Link>
              <Link to="/contact" className="text-muted-foreground hover:text-accent transition-colors">
                Contactez-nous
              </Link>
              <Link to="/confidentialite" className="text-muted-foreground hover:text-accent transition-colors">
                Confidentialité
              </Link>
              <Link to="/cgv" className="text-muted-foreground hover:text-accent transition-colors">
                Conditions d&apos;utilisation
              </Link>
            </div>
          </div>

          {/* Newsletter */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Abonnez-vous</h3>
            <p className="text-sm text-muted-foreground">
              Restez informé avec Agro! Abonnez-vous à notre newsletter pour les dernières actualités, innovations et conseils pour optimiser votre production laitière.
            </p>
            <div className="space-y-2">
              <Input 
                type="text" 
                placeholder="Prénom" 
                className="bg-gray-50"
              />
              <Input 
                type="email" 
                placeholder="E-mail" 
                className="bg-gray-50"
              />
              <Button className="w-full bg-[#2c2c2c] hover:bg-[#3c3c3c] text-white">
                Je m&apos;abonne!
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <p className="text-sm text-center text-muted-foreground">
            © {currentYear} Agro | Site web créé par <span className="font-semibold">Pierrick Thierry</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
